export const DEFAULT_EDITOR_VALUE = "<p><br></p>";
export const EMAIL_REGEX=/^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]*[a-zA-Z]+[a-zA-Z0-9-]*)(\.[a-zA-Z]{2,})+$/;
export const NUMBER_REGEX=/^(?!([6-9])\1{9})[6-9]\d{9}$/
